export default "__VITE_ASSET__DnNLIilp__"